import React from 'react';
import { ScrollView, StyleSheet, ListRenderItemInfo, FlatList, View, Platform } from 'react-native';
import { Text, List, Button, Layout, CardHeader, ListItem, Icon, Spinner} from '@ui-kitten/components';


import { useQuery } from '@apollo/react-hooks';
import { Q_GET_SURVEY_AND_RESPONSE_COUNT } from '../data/api/query/q_survey';
import { Q_GET_CAMPAIGNS } from '../data/api/query/q_campaigns';
import { SurveyCard, CardItem, CampaignCard, PollCard } from '../components/list-items/CardItem';
import { Campaign, Survey } from '../data/models/types';
import { handleExpiredJWT } from '../utils/handleExpiredJWT';
import { ModalLoadingIndicator, PageLoadingIndicator } from '../components/LoadingIndicator';
import { AuthContext } from '../App';
import { NoSurveyCard } from '../components/surveys/NoSurveyCard';
import { useScreenDimensions } from '../utils/useScreenInfo';
import { PlanTypeOptions } from './home.screen';
import { getPublicSurveyUrl } from '../utils/LinkHelpers';
import { BrandText } from '../components/brandText';
import { Card, BasicCard, useTheme } from '../components/_primatives';
import { CommonActions } from '@react-navigation/native';







export default function DashboardScreen({ navigation }) {
    const { user } = React.useContext(AuthContext);
    if (user.product_plan.id === 3 && user.product_plan.title === PlanTypeOptions.PLATINUM) {
        return <>
            {/* <Text>{PlanTypeOptions.PLATINUM}</Text> */}
            <PlatinumDashboardScreen navigation={navigation} user={user} />
        </>
    }
    else if (user.product_plan.id === 2 && user.product_plan.title === PlanTypeOptions.PREMIUM) {
        return <>
            {/* <Text>{PlanTypeOptions.PREMIUM}</Text> */}
            <PremiumDashboardScreen navigation={navigation} user={user} />
        </>
    }
    else {
        return <>
            {/* <Text>{PlanTypeOptions.BASIC}</Text> */}
            <BasicDashboardScreen navigation={navigation} user={user} />
        </>
    }
}

function PlatinumDashboardScreen({ navigation, user }) {

    // navigation.navigate('Groups', { });
    // navigation.navigate('ManageSurvey', { survey_id: '5eb72e57-2c28-4451-a51a-712a7d198c3d' });
    // navigation.navigate('SurveyResults', { survey_id: '5eb72e57-2c28-4451-a51a-712a7d198c3d' });
    // const { user } = React.useContext(AuthContext);
    const { pageSpacerHorizontal } = useScreenDimensions();
    const surveyRequest = useQuery(Q_GET_SURVEY_AND_RESPONSE_COUNT, { variables: { author_id: user.id }, fetchPolicy: 'network-only' });
    const campaignRequest = useQuery(Q_GET_CAMPAIGNS, { fetchPolicy: 'network-only' });
    const _onRefresh = () => { surveyRequest.refetch(); campaignRequest.refetch(); }

    if (surveyRequest.loading || campaignRequest.loading) {
        return <PageLoadingIndicator />;
    }
    if (surveyRequest.error)  {
        console.log('HomeScreen error', surveyRequest.error || campaignRequest.error);
        handleExpiredJWT(surveyRequest.error, () => {
            navigation.navigate('LoginOrSignup', { actionType: 'login' });
        });
        return <Button onPress={_onRefresh}>Error :(</Button>
    };
    if (campaignRequest.error)  {
        console.log('HomeScreen error', campaignRequest.error);
    };
    console.log('we have data, ', surveyRequest.data, campaignRequest.data)
    const campaigns: Campaign[] = campaignRequest?.data?.campaigns;

    const renderCardItem = (info: ListRenderItemInfo<CardItem>) => (
        <CampaignCard
            item={info.item}
            onPress={() => navigation.navigate('Campaigns', { screen: 'Campaign', params: { campaign: info.item.id } })}
            // style={{ height: 200, width: 250 }]}
            style={{ minWidth: 300, maxWidth: 350 }}
        />
    );

    const renderSurveyItem = (info: ListRenderItemInfo<CardItem>) => (
        <SurveyCard
            item={info.item}
            onPress={() => navigation.navigate('Surveys', { screen: 'Survey', params: { survey: info.item.id } })}
            style={{ marginLeft: pageSpacerHorizontal, marginRight: 25 }}
        />
    );

    const listHeader = () => (
        <>
            <Text style={[{ marginLeft: 25, marginBottom: 25, marginTop: 50 }]} category='s1'>
                CAMPAIGNS
            </Text>
            <FlatList
                contentContainerStyle={[{ paddingLeft: pageSpacerHorizontal }]}
                horizontal={true}
                showsHorizontalScrollIndicator={false}
                data={campaigns}
                renderItem={renderCardItem}
                ItemSeparatorComponent={() => <View style={{ width: 25 }}></View>}
                ListFooterComponent={() => listFooterComponent([{ height: 200, width: 250 }], 'Campaigns')}
                keyExtractor={(item) => item.id}
            />
            <Text style={[{ marginLeft: 25, marginBottom: 25, marginTop: 50 }]} category='s1'>
                MY SURVEYS
            </Text>
        </>
    );

    const listFooterComponent = (style: any, routeName: string) => (
        <View style={[{ justifyContent: 'center', alignItems: 'center', backgroundColor: 'transparent' }, style]}>
            <Button appearance='outline' onPress={() => console.log(navigation.navigate(routeName))}>View All</Button>
        </View>
    );
    const listEmptyComponent = () => (
        <BasicCard style={{ marginTop: 25, marginBottom: 25, marginLeft: 25, marginRight: 25 }}>
            <NoSurveyCard
                subtitle={'You don\'t have any surveys'}
            />
        </BasicCard>
    )

    return (
        <Layout level='3' style={{ flex: 1 }}>
            <FlatList
                style={{ flex: 1 }}
                data={surveyRequest.data.surveys}
                renderItem={renderSurveyItem}
                ItemSeparatorComponent={() => <View style={{ height: 25 }}></View>}
                ListEmptyComponent={listEmptyComponent}
                ListHeaderComponent={listHeader}
                ListFooterComponent={() => listFooterComponent([{marginTop: 25, marginBottom: 25, marginLeft: 25, marginRight: 25}], 'Surveys')}
                keyExtractor={(item) => item.id}
            />
        </Layout>
    );
}


function PremiumDashboardScreen({ navigation, user }) {

    // navigation.navigate('Groups', { });
    // navigation.navigate('ManageSurvey', { survey_id: '5eb72e57-2c28-4451-a51a-712a7d198c3d' });
    // navigation.navigate('SurveyResults', { survey_id: '5eb72e57-2c28-4451-a51a-712a7d198c3d' });
    // const { user } = React.useContext(AuthContext);
    const { pageSpacerHorizontal } = useScreenDimensions();
    const surveyRequest = useQuery(Q_GET_SURVEY_AND_RESPONSE_COUNT, { variables: { author_id: user.id }, fetchPolicy: 'network-only' });
    const campaignRequest = useQuery(Q_GET_CAMPAIGNS, { fetchPolicy: 'network-only' });
    const _onRefresh = () => { surveyRequest.refetch(); campaignRequest.refetch(); }

    if (surveyRequest.loading || campaignRequest.loading) {
        return <PageLoadingIndicator />;
    }
    if (surveyRequest.error)  {
        console.log('HomeScreen error', surveyRequest.error || campaignRequest.error);
        handleExpiredJWT(surveyRequest.error, () => {
            navigation.navigate('LoginOrSignup', { actionType: 'login' });
        });
        return <Button onPress={_onRefresh}>Error :(</Button>
    };
    if (campaignRequest.error)  {
        console.log('HomeScreen error', campaignRequest.error);
    };
    console.log('we have data, ', surveyRequest.data, campaignRequest.data)
    const campaigns: Campaign[] = campaignRequest?.data?.campaigns;

    const renderCardItem = (info: ListRenderItemInfo<CardItem>) => (
        <CampaignCard
            item={info.item}
            onPress={() => navigation.navigate('Campaigns', { screen: 'Campaign', params: { campaign: info.item.id } })}
            // style={{ height: 200, width: 250 }]}
            style={{ minWidth: 300, maxWidth: 350 }}
        />
    );

    const renderSurveyItem = (info: ListRenderItemInfo<CardItem>) => (
        <SurveyCard
            item={info.item}
            onPress={() => navigation.navigate('Surveys', { screen: 'Survey', params: { survey: info.item.id } })}
            style={{ marginLeft: pageSpacerHorizontal, marginRight: 25 }}
        />
    );

    const listHeader = () => (
        <>
            <Text style={[{ marginLeft: 25, marginBottom: 25, marginTop: 50 }]} category='s1'>
                CAMPAIGNS
            </Text>
            <FlatList
                contentContainerStyle={[{ paddingLeft: pageSpacerHorizontal }]}
                horizontal={true}
                showsHorizontalScrollIndicator={false}
                data={campaigns}
                renderItem={renderCardItem}
                ItemSeparatorComponent={() => <View style={{ width: 25 }}></View>}
                ListFooterComponent={() => listFooterComponent([{ height: 200, width: 250 }], 'Campaigns')}
                keyExtractor={(item) => item.id}
            />
            <Text style={[{ marginLeft: 25, marginBottom: 25, marginTop: 50 }]} category='s1'>
                MY SURVEYS
            </Text>
        </>
    );

    const listFooterComponent = (style: any, routeName: string) => (
        <View style={[{ justifyContent: 'center', alignItems: 'center', backgroundColor: 'transparent' }, style]}>
            <Button appearance='outline' onPress={() => console.log(navigation.navigate(routeName))}>View All</Button>
        </View>
    );
    const listEmptyComponent = () => (
        <Card style={{ marginTop: 25, marginBottom: 25, marginLeft: 25, marginRight: 25 }}>
            <NoSurveyCard
                subtitle={'You don\'t have any surveys'}
            />
        </Card>
    )

    return (
        <Layout level='3' style={{ flex: 1 }}>
            <FlatList
                // contentContainerStyle={{ paddingTop: 25, paddingBottom: 25 }}
                style={{ flex: 1 }}
                data={surveyRequest.data.surveys}
                renderItem={renderSurveyItem}
                ItemSeparatorComponent={() => <View style={{ height: 25 }}></View>}
                ListEmptyComponent={listEmptyComponent}
                ListHeaderComponent={listHeader}
                ListFooterComponent={() => listFooterComponent([{marginTop: 25, marginBottom: 25, marginLeft: 25, marginRight: 25}], 'Surveys')}
                keyExtractor={(item) => item.id}
            />
        </Layout>
    );
}


function BasicDashboardScreen({ navigation, user }) {
    const { pageSpacerHorizontal, isMediumScreenOrLarger, bodyWidth } = useScreenDimensions();
    const theme = useTheme();
    const MAIN_COLOR: string = theme['color-primary-default'];
    const level: string = '1';
    const _renderHeader = () => (
        <View style={{ marginVertical: 20, marginBottom: 30, paddingHorizontal: isMediumScreenOrLarger ? 0 : 23 }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap' }}>
                <View>
                    <Text category='h1'>{'Home'}</Text>
                    <View style={{ width: 90, backgroundColor: MAIN_COLOR, height: 4 }}></View>
                </View>
                    {/* {profileData.avatar ?
                        <Avatar source={{ uri: profileData.avatar }} size={'giant'} style={{  alignSelf: 'flex-end'}} />
                        : undefined
                    } */}
            </View>
        </View>
    );
    return (
        <Layout level={'1'} style={{ flex: 1 }}>
            <ScrollView
                style={{ flex: 1, paddingHorizontal: pageSpacerHorizontal }}
                contentContainerStyle={isMediumScreenOrLarger ? { width: bodyWidth, alignSelf: 'center', paddingTop: 0 } : { paddingHorizontal: pageSpacerHorizontal }}
            >
                <View style={{ flex: 1 }}>
                    {_renderHeader()}
                    <AnnouncementCard />
                    <View style={isMediumScreenOrLarger ?
                        { flex: 1, flexDirection: 'row', alignItems: 'baseline', justifyContent: 'space-between'}
                        : { flex: 1, flexDirection: 'column' }
                    }>
                        <Layout style={isMediumScreenOrLarger ? { flex: 1, marginRight: 20 } : { marginBottom: 20 }}>
                            <SurveyList navigation={navigation} user={user} />
                        </Layout>

                        <Layout style={{ flex: 1 }}>
                            <PollList navigation={navigation} user={user} />
                        </Layout>
                    </View>
                </View>
            </ScrollView>
        </Layout>
    );
}

function PollList({ navigation, user }) {

    // navigation.navigate('SurveyResults', { survey_id: '5eb72e57-2c28-4451-a51a-712a7d198c3d' });
    const { pageSpacerHorizontal, isMediumScreenOrLarger } = useScreenDimensions();
    const surveyRequest = useQuery(Q_GET_SURVEY_AND_RESPONSE_COUNT, {
        variables: { author_id: user.id, survey_type_id: 2, limit: 3 },
        fetchPolicy: 'network-only'
    });
    const _onRefresh = () => { surveyRequest.refetch(); }

    if (surveyRequest.loading) {
        return <BasicCard><ModalLoadingIndicator modalVisible /></BasicCard>;
    }

    if (surveyRequest.error)  {
        console.log('HomeScreen error', surveyRequest.error);
        handleExpiredJWT(surveyRequest.error, () => {
            navigation.navigate('LoginOrSignup', { actionType: 'login' });
        });
        return <Button onPress={_onRefresh}>Error :(</Button>
    };





    const renderHeader = () => (
        <BasicCard style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderBottomWidth: 0 }}>
            <Text category='h4'>{'Polls'}</Text>
        </BasicCard>
    );
    const renderFooter = () => (
        <BasicCard style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0, borderTopWidth: 0 }}>
            <Button appearance='outline'  onPress={() => navigation.navigate('Polls', { screen: 'All' })} style={{ maxWidth: 193 }}>View All</Button>
            <Text category='p1'>{'\n'}</Text>
        </BasicCard>
    );
    const renderSurvey = (item: Survey) => (
        <BasicCard
            onPress={() => {
                setTimeout(() => navigation.navigate('Polls', { screen: 'Poll', params: { id: item.id } }), 1);
                navigation.navigate('Polls', { screen: 'Add' });
            }}
            style={[{ borderRadius: 0, borderTopWidth: 0, borderBottomWidth: 0 }]}
        >
            <View style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', }}>
                <Icon name={'bar-chart-outline'} style={{ marginRight: 20 }} height={25} width={25} fill='rgb(143, 155, 179)'/>
                <View style={{ flex: 1 }}>
                    <Text category='s1' style={{ fontWeight: 'bold' }}>{item.title}</Text>
                    <Text category='p1' appearance='hint'>{item.description}</Text>
                </View>
            </View>
        </BasicCard>
    );
    const listEmptyComponent = () => (
        <BasicCard style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0, borderTopWidth: 0 }}>
            <Text category='s1' style={{ marginBottom: 40 }}>{'Create your first Poll'}</Text>
            <Button appearance='outline' onPress={() => navigation.navigate('Polls', { screen: 'CreatePoll' })}>Create Poll</Button>
            <Text category='p1'>{'\n'}</Text>
        </BasicCard>
    );

    return (
        <>
            {renderHeader()}
            {surveyRequest?.data?.surveys?.length ? surveyRequest.data.surveys.map(renderSurvey) : undefined}
            {surveyRequest?.data?.surveys?.length ? renderFooter() : listEmptyComponent()}
        </>
    );
}

function SurveyList({ navigation, user }) {
    const { pageSpacerHorizontal, isMediumScreenOrLarger } = useScreenDimensions();
    let surveyRequest = useQuery(Q_GET_SURVEY_AND_RESPONSE_COUNT, {
        variables: { author_id: user.id, survey_type_id: 1, limit: 3 },
        fetchPolicy: 'network-only' 
    });
    const _onRefresh = () => { surveyRequest.refetch(); }

    if (surveyRequest.loading) {
        return <BasicCard><ModalLoadingIndicator modalVisible /></BasicCard>;
    }
    if (surveyRequest.error)  {
        console.log('HomeScreen error', surveyRequest.error);
        handleExpiredJWT(surveyRequest.error, () => {
            navigation.navigate('LoginOrSignup', { actionType: 'login' });
        });
        return <Button onPress={_onRefresh}>Error :(</Button>
    };

    const renderHeader = () => (
        <BasicCard style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderBottomWidth: 0 }}>
            <Text category='h4'>{'Surveys'}</Text>
        </BasicCard>
    );
    const renderFooter = () => (
        <BasicCard style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0, borderTopWidth: 0 }}>
            <View>
            <Button appearance='outline' onPress={() => navigation.navigate('Surveys', { screen: 'All' })} style={{ maxWidth: 193 }}>View All</Button>
            </View>
            <Text category='p1'>{'\n'}</Text>
        </BasicCard>
    );
    const renderSurvey = (item: Survey) => (
        <BasicCard
            onPress={() => {
                console.log('dash => all surveys ')
                setTimeout(() => navigation.navigate('Surveys', { screen: 'Survey', params: { survey: item.id } }), 1);
                navigation.navigate('Surveys', { screen: 'All' });
            }}
            style={{ borderRadius: 0, borderTopWidth: 0, borderBottomWidth: 0 }}
        >
            <View style={{ flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', }}>
                <Icon name={'clipboard-outline'} style={{ marginRight: 20 }} height={25} width={25} fill='rgb(143, 155, 179)'/>
                <View style={{ flex: 1 }}>
                    <Text category='s1' style={{ fontWeight: 'bold' }}>{item.title}</Text>
                    <Text category='p1' appearance='hint'>{item.description}</Text>
                </View>
            </View>
        </BasicCard>
    );
    const listEmptyComponent = () => (
        <BasicCard style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0, borderTopWidth: 0 }}>
            <Text category='s1' style={{ marginBottom: 40 }}>{'Create your first Survey'}</Text>
            <Button appearance='outline' onPress={() => navigation.navigate('Surveys', { screen: 'CreateSurvey' })}>Create Survey</Button>
            <Text category='p1'>{'\n'}</Text>
        </BasicCard>
    );

    return (
        <>
            {renderHeader()}
            {surveyRequest?.data?.surveys?.length ? surveyRequest.data.surveys.map(renderSurvey) : undefined}
            {surveyRequest?.data?.surveys?.length ? renderFooter() : listEmptyComponent()}
        </>
    );
}


export const AnnouncementCard = () => {
    const feedbackUrl = getPublicSurveyUrl('0e99bed4-a033-4be0-a673-fd34fe2bd3dc');
    const { isMediumScreenOrLarger } = useScreenDimensions();

    return isMediumScreenOrLarger ? 
        (
            <BasicCard style={{ padding: 0, marginVertical: 20 }}>
                <Layout style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
                    <BrandText status='primary' category='h5' style={{ textAlign: 'center', marginRight: 20 }}>pll</BrandText>
                    <Layout style={{ flex: 1 }}>
                        <Text category='s1' style={{ flex: 1 }}>Welcome to Poall 😎</Text>
                        <Text appearance='hint' style={{ flex: 1 }}>We are currently in Beta and could use your help!</Text>
                    </Layout>
                    <Button appearance='outline' accessibilityRole='link' href={feedbackUrl} target='_blank'>
                        {`Help Make Poall Better`}
                    </Button>
                </Layout>
            </BasicCard>
        )
    : (
        <BasicCard style={{ padding: 0, marginVertical: 20 }}>
            <Layout style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', marginBottom: 10 }}>
                <BrandText status='primary' category='h5' style={{ textAlign: 'center', marginRight: 20 }}>pll</BrandText>
                <Layout style={{ flex: 1 }}>
                    <Text category='s1' style={{ flex: 1 }}>Welcome to Poall 😎</Text>
                    <Text appearance='hint' style={{ flex: 1 }}>We are currently in Beta and could use your help!</Text>
                </Layout>
            </Layout>
            <Button appearance='outline' accessibilityRole='link' href={feedbackUrl} target='_blank'>
                {`Help Make Poall Better`}
            </Button>
        </BasicCard>
    )
}



